import React from 'react';
import { Alert, Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import routes from 'constants/routes';

interface Props {
	saleOrderId: string;
	crmTicket: number;
}

export const WizardOrderCreatedBanner = ({ saleOrderId, crmTicket }: Props): JSX.Element => {
	const orderUrl = routes.salesOrder.edit.replace(':id', saleOrderId);

	return (
		<Alert severity="info" sx={{ mb: 3 }}>
			<Typography variant="body2" component="div" gutterBottom>
				<strong>La orden de venta para el caso {crmTicket} ya fue creada.</strong> Podés abrirla en cualquier momento
				desde{' '}
				<Link component={RouterLink} to={orderUrl} fontWeight={600}>
					este enlace
				</Link>
				.
			</Typography>
			<Typography variant="body2" component="div">
				A continuación, en cada paso del asistente, se irán agregando los servicios correspondientes (pasajeros, vuelos,
				hoteles y demás). Si necesitás ajustar algo, podés ir a la orden en cualquier momento; cuando termines la carga
				acá, el asistente finaliza y seguís trabajando en la pantalla habitual de la orden.
			</Typography>
			<Box mt={1}>
				<Typography variant="caption" color="text.secondary">
					ID orden: {saleOrderId}
				</Typography>
			</Box>
		</Alert>
	);
};
